export default "__VITE_ASSET__CK432OFf__"